import { render } from "./EventStart.vue?vue&type=template&id=4c068c85"
import script from "./EventStart.vue?vue&type=script&lang=js"
export * from "./EventStart.vue?vue&type=script&lang=js"

import "./EventStart.vue?vue&type=style&index=0&id=4c068c85&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__